import { message } from 'antd';
import { extend } from 'umi-request';
import request, { requestAdapter } from '@parallel-line/request';

request.extendOptions({
  adapter: requestAdapter(extend({ getResponse: true })),
  message: {
    info(content) {
      message.error(content);
    },
    success(content) {
      message.error(content);
    },
    error(content) {
      message.error(content);
    },
    warn(content) {
      message.error(content);
    },
  },
});

// @ts-ignore
window['TARO'] = {};
